var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{attrs:{"loading":_vm.loading,"outlined":""}},[_c('div',{staticClass:"text-center font-weight-bold mb-2"}),_c('div',{attrs:{"id":"chartdiv"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }